module.exports = __webpack_public_path__ + "img/alert-circle-outline.b5ddf451.svg";